import React, { Component } from 'react';
import './App.css';
import { Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { Login } from './components/Login.js';
import { ApiTesting } from './components/ApiTesting.js';
import { Devices } from './components/Devices.js';
import { SingleDevice } from './components/SingleDevice.js';
import { SingleSubDevice } from './components/SingleSubDevice.js';
import { GatewayChoose } from './components/GatewayChoose.js';
import { Dashboard } from './components/Dashboard.js';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = { token: this.isLogged() };
  }

  isLogged() {
    let val = this.readCookie('unithings_token');
    if (val != null) {
      return val;
    }
    return 0;
  }

  readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  render() {
    return (
      <BrowserRouter>
        <div className="app-wrapper">
          { this.renderElements() }
        </div>
      </BrowserRouter>
    );
  }

  renderElements() {
    if(this.state.token) {
      // <Route exact path="/gateway-:force" render={(props) => <GatewayChoose token={this.state.token} {...props} />} />
      // <Route exact path="/gateway" render={(props) => <GatewayChoose token={this.state.token} {...props} />} />
      return (
        <div>
          <Route exact path="/" render={(props) => <Dashboard token={this.state.token} {...props} />} />
          <Route exact path="/devices" render={(props) => <Devices token={this.state.token} {...props} />} />
          <Route exact path="/devices/device-:id" render={(props) => <SingleDevice token={this.state.token} {...props} />} />
          <Route exact path="/devices/device-:id/sub-:ieee" render={(props) => <SingleSubDevice token={this.state.token} {...props} />} />
          <Route exact path="/test-api" render={(props) => <ApiTesting token={this.state.token} {...props} />} />
        </div>
      );
    }
    return (
      <Login />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js